import { axiosInst } from "../main";
import BaseService from "./base-service";

export default class ProjectService extends BaseService {
    
    async fetchAll( params, loadingCallback )  {
        const response = await axiosInst.get('/public/projects', {
            params: params
        })
        
        this.handleCallback(loadingCallback)
        return response
    }

    async update( id, data, params, loadingCallback )  {
        let path = (id) => `/public/projects/${id}`
        const response = await axiosInst.put( path(id, cid), data, {
            params: params
        })
        
        this.handleCallback(loadingCallback)
        return response
    }

    async search( params, loadingCallback )  {
        const response = await axiosInst.get('/public/projects', {
            params: params
        })
        
        this.handleCallback(loadingCallback)
        return response
    }
    
}